/* eslint-disable react/require-default-props */

import React from 'react';
import PropTypes from 'prop-types';
import { FontAwesome } from '../../FontAwesome';
import { BootstrapModal } from '../../BootstrapModal/BootstrapModal';
import { ModalBody } from '../Helpers/index';
import './Loading.scss';

export const LoadingDialog = (props) => {
  const { heading, body } = props;
  return (
    <BootstrapModal {...props}>
      <loading-dialog>
        <ModalBody>
          {heading && <h3>{heading}</h3>}
          {body && <p>{body}</p>}
          <FontAwesome name="spinner" size="3x" fixedWidth pulse />
        </ModalBody>
      </loading-dialog>
    </BootstrapModal>
  );
};
LoadingDialog.propTypes = {
  heading: PropTypes.string,
  body: PropTypes.string,
};
